var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M7.396 3.808a2.25 2.25 0 0 1 3.141.04l5.14 5.14a.25.25 0 0 1 .073.176V15.5a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75V8.805c0-.069.028-.135.078-.182z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M6.375 15.875V12.5a2.625 2.625 0 0 1 5.25 0v3.375"
  })));
};
export default SvgHome;